import { throws } from "assert";
import Settings from "../settings";
import { UIScene } from "../ui/UITypes";

export enum BaoAction {
  idle = "idle",
  celebrating = "celebrating",
  crying = "crying",
  jump = "jump",
  head = "head",
  tail = "tail",
}

export default class Bao {
  scene: UIScene;
  bao: Phaser.GameObjects.Sprite;
  isAdjusted: boolean;
  onFinish: Function;

  offsetPosition: { x: number; y: number };
  constructor(scene: UIScene, position: { x: number; y: number }, onFinish) {
    this.scene = scene;
    this.offsetPosition = position;
    this.isAdjusted = false;
    this.onFinish = onFinish;
  }

  load() {
    this.scene.load.atlas(
      "bao_animation",
      "assets/bao/Bao.png",
      "assets/bao/Bao.json"
    );
    this.scene.load.atlas(
      "bao_animation_toss",
      "assets/bao/BaoToss.png",
      "assets/bao/BaoToss.json"
    );
  }

  create() {
    this.scene.anims.create({
      key: "celebrating",
      frames: this.scene.anims.generateFrameNames("bao_animation", {
        prefix: "Bao_Spin-Celebrating_",
        suffix: ".png",
        end: 42,
        zeroPad: 2,
      }),
      repeat: 0,
    });
    this.scene.anims.create({
      key: "crying",
      frames: this.scene.anims.generateFrameNames("bao_animation", {
        prefix: "Bao_Spin-Crying_",
        suffix: ".png",
        end: 64,
        zeroPad: 2,
      }),
      repeat: 0,
    });
    this.scene.anims.create({
      key: "idle",
      frames: this.scene.anims.generateFrameNames("bao_animation", {
        prefix: "Bao_Spin-Idle_",
        suffix: ".png",
        end: 32,
        zeroPad: 2,
      }),
      repeat: -1,
    });
    this.scene.anims.create({
      key: "jump",
      frames: this.scene.anims.generateFrameNames("bao_animation", {
        prefix: "Bao_Spin-Jump_",
        suffix: ".png",
        end: 46,
        zeroPad: 2,
      }),
      repeat: 0,
    });
    this.scene.anims.create({
      key: "tail",
      frames: this.scene.anims.generateFrameNames("bao_animation_toss", {
        prefix: "Bao_Spin-Toss Coin_1_",
        suffix: ".png",
        end: 72,
        zeroPad: 2,
      }),
      duration: 2200,
      repeat: 0,
    });
    this.scene.anims.create({
      key: "head",
      frames: this.scene.anims.generateFrameNames("bao_animation_toss", {
        prefix: "Bao_Spin-Toss Coin_2_",
        suffix: ".png",
        end: 72,
        zeroPad: 2,
      }),
      duration: 2200,
      repeat: 0,
    });
    this.bao = this.scene.add.sprite(400, 300, "bao_animation");

    this.bao.on("animationstart", (currentAnim) => {
      if (currentAnim.key === BaoAction.idle) {
        if (this.isAdjusted) {
          this.isAdjusted = false;
          this.bao.x -= 30;
          this.bao.y -= 10;
        }
      }
    });

    this.bao.on("animationcomplete", (currentAnim) => {
      if (
        currentAnim.key === BaoAction.head ||
        currentAnim.key === BaoAction.tail
      ) {
        this.onFinish();
      }
    });

    //Scale
    this.scaleResponsively(this.bao, 0.5);
  }

  scaleResponsively(target, scale) {
    let width =
      window.innerWidth > Settings.MAX_MOBILE_WIDTH
        ? Settings.MAX_MOBILE_WIDTH
        : window.innerWidth;
    let height = window.innerHeight;

    target.x = width / 2;
    target.y = height / 2;
    let WheelscaleX = width / target.width;
    let WheelscaleY = height / target.height;
    let Wheelscale = Math.max(WheelscaleX, WheelscaleY) * scale;
    target.setScale(Wheelscale).setScrollFactor(0);
  }

  setPosition(x: number, y: number) {
    const offsetX = this.offsetPosition.x * this.bao.scaleX;
    const offsetY = this.offsetPosition.y * this.bao.scaleY;

    this.bao.setPosition(x + offsetX, y + offsetY);
  }

  update() {}

  play(action: BaoAction) {
    this.bao.play(action);
    if (action !== BaoAction.idle) this.bao.playAfterRepeat(BaoAction.idle);
  }
}
